module.exports = __webpack_public_path__ + "static/media/transport.bfa1ca23.png";